import React from "react";

const Header = () => {
     <header className="sticky top-0 z-50 bg-gray-900 shadow-lg">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
      <h1 className="text-2xl font-bold text-indigo-400 font-inter">Anton Berisha</h1>
      <nav className="hidden md:flex space-x-6">
        <a href="#about" className="text-gray-300 hover:text-indigo-400 transition duration-150">About</a>
        <a href="#projects" className="text-gray-300 hover:text-indigo-400 transition duration-150">Projects</a>
        <a href="#contact" className="text-gray-300 hover:text-indigo-400 transition duration-150">Contact</a>
      </nav>
    </div>
  </header>
}

export default Header